export function useDateFormatter(dateString: any) {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  let formattedDate = "";

  if (useRuntimeConfig().public.theme.site === "mountexro") {
    formattedDate = `${day}/${month}/${year}`;
  } else {
    formattedDate = `${year}.${month}.${day}`;
  }

  return formattedDate;
}
